import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginClient"] */ "/vercel/path0/src/app/(frontend)/[lang]/login/LoginClient.tsx");
